module.exports = __webpack_public_path__ + "static/media/tiffany_pham.9c3828b3.png";